import { createSlice } from '@reduxjs/toolkit'
import { service } from '../shared/_services/api_service'
import { setLoading } from './loader';
import { errorHandler, successHandler } from '../shared/_helper/responseHelper';

const initialState = {
  mockTestData: [],
  totalmockTest: 0,
  isOpenModal: false,
  isStatusOpenModal: false,
}

export const mockTestSlice = createSlice({
  name: "mockTest",
  initialState,
  reducers: {
    setmockTestData(state, { payload }) {
      state.mockTestData = payload.result
      state.totalmockTest = payload.total
    },
    updatemockTestData(state, { payload }) {
      const objIndex = state.mockTestData.findIndex((obj) => obj._id === payload._id);
      if (objIndex >= 0) {
        state.mockTestData[objIndex] = payload
      }
    },
    deletemockTestData(state, { payload }) {
      const objIndex = state.mockTestData.findIndex((obj) => obj._id === payload);
      if (objIndex >= 0) {
        state.mockTestData.splice(objIndex, 1)
      }
    },
    pushmockTestData(state, { payload }) {
      state.mockTestData.push(payload)
    },

    isOpenModal(state, { payload }) {
      state.isOpenModal = payload
    },
    ModalToggle(state, { payload }) {
      state.isOpenModal = !state.isOpenModal
    },
    isOpenStatusModal(state, { payload }) {
      state.isStatusOpenModal = payload
    },
    statusToggle(state, { payload }) {
      state.isStatusOpenModal = !state.isStatusOpenModal
    }
  }
})

export const { setmockTestData, updatemockTestData, deletemockTestData, pushmockTestData, isOpenModal,
  ModalToggle, setFaqsSpecializationData, isOpenStatusModal, statusToggle } = mockTestSlice.actions;

export default mockTestSlice.reducer;

export function getmockTest(limit, offset, status, keyword, id) {
  return async function getmockTestThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.getmockTest(limit, offset, status, keyword, id).then(
        (response) => {
          dispatch(setLoading(false))
          dispatch(setmockTestData(response.data))
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function addmockTest(payload) {
  return async function addmockTestThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.addmockTest(payload).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(pushmockTestData(response.data))
          successHandler('Added Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function updatemockTest(id, data,) {
  return async function updatemockTestThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.updatemockTest(id, data).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(updatemockTestData(response.data))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}

export function statusUpdatemockTest(payload) {
  return async function statusUpdatemockTestThunk(dispatch) {
    try {
      dispatch(setLoading(true))
      await service.statusUpdatemockTest(payload.id, payload.status).then(
        (response) => {
          dispatch(statusToggle())
          dispatch(updatemockTestData(response.data))
          dispatch(setLoading(false))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function statusDeletemockTest(payload) {
  return async function statuseletemockTestThunk(dispatch) {
    try {
      dispatch(setLoading(true))
      await service.statusUpdatemockTest(payload.id, payload.status).then(
        (response) => {
          dispatch(deletemockTestData(payload.id))
          dispatch(setLoading(false))
          successHandler('Deleted Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}

